import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  error: {
    id: 'studio.KNWBbl',
    defaultMessage: 'There was a problem loading the history for this resource',
  },
  loading: {
    id: 'studio.SIETYz',
    defaultMessage: 'Loading resource history…',
  },
});
